import React from 'react';

import alertCaller from '@core/app/actions/alert-caller';
import { addDialogComponent, isIdExist, popDialogById } from '@core/app/actions/dialog-controller';
import progressCaller from '@core/app/actions/progress-caller';
import deviceMaster from '@core/helpers/device-master';

import LaserDelaySettingPanel from './LaserDelaySettingPanel';

const parseLaserDelay = (raw: string): Record<string, number> => {
  const normalized = raw.replace(/'/g, '"');

  return JSON.parse(normalized) as Record<string, number>;
};

const generateDefaultData = (): Record<string, number> => {
  const data: Record<string, number> = {};

  for (let speed = 100; speed <= 2000; speed += 100) {
    data[`S${speed}`] = 1500;
  }

  return data;
};

export const showLaserDelaySettingPanel = async (): Promise<void> => {
  const id = 'laser-delay-setting';

  if (isIdExist(id)) {
    return;
  }

  progressCaller.openNonstopProgress({ id: 'fetch-laser-delay', message: 'Fetching laser delay settings' });

  let initData: Record<string, number>;

  try {
    const res = await deviceMaster.getDeviceSetting('laser_delay');

    if (res.status === 'ok') {
      initData = parseLaserDelay(res.value);
    } else {
      alertCaller.popUpError({ message: `Failed to get laser_delay: ${JSON.stringify(res)}` });
      initData = generateDefaultData();
    }
  } catch (error) {
    let errorMessage: string;

    if (error instanceof Error) {
      errorMessage = error.message;
    } else {
      try {
        errorMessage = JSON.stringify(error);
      } catch {
        errorMessage = String(error);
      }
    }

    alertCaller.popUpError({ message: `Failed to get laser_delay: ${errorMessage}` });
    initData = generateDefaultData();
  } finally {
    progressCaller.popById('fetch-laser-delay');
  }

  addDialogComponent(id, <LaserDelaySettingPanel initData={initData} onClose={() => popDialogById(id)} />);
};
